import dateComparator from "./DateComparator";
import filterParams from "./DateFilter";

export const columnDefs = [
  {
    headerName: "Numero",
    valueGetter: "node.rowIndex + 1",
    width: 90,
    suppressSizeToFit: false,
    checkboxSelection: true,
    minWidth: 90,
    maxWidth: 90,
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_PriseEnCharge");
      // eslint-disable-next-line
      if (params?.data?.idPriseEnCharge == ID) {
        return "aggridGoBackStylesPriseEnCharge";
      } else {
        return "null";
      }
    },

    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_Session");
    //   if (params.data.fk_id_patient1 == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null"
    //   }
    // },
  },
  {
    floatingFilter: true,
    headerName: "Clinique",
    field: "NomClinique",
    // hide: true,
    // cellClass: (params) => {
    //   let ID = sessionStorage.getItem("ID_PriseEnCharge");
    //   // eslint-disable-next-line
    //   if (params?.data?.idPriseEnCharge == ID) {
    //     return "aggridGoBackStyles";
    //   } else {
    //     return "null";
    //   }
    // },
  },
  // ,cin,date_naissance
  {
    headerName: "date_naissanceLisible",
    field: "date_naissanceLisible",
    hide: true,
  },
  {
    headerName: "cin",
    field: "cin",
    hide: true,
  },
  {
    headerName: "FK_id_medecin2",
    field: "FK_id_medecin2",
    hide: true,
  },
  {
    headerName: "FK_id_Patient_Prise",
    field: "FK_id_Patient_Prise",
    hide: true,
  },
  {
    headerName: "idPriseEnCharge",
    field: "idPriseEnCharge",
    hide: true,
  },
  {
    headerName: "civilite",
    field: "civilite",
    hide: true,
  },

  {
    floatingFilter: true,
    headerName: "Nom",
    field: "NomPrenom",
    cellClass: (params) => {
      let duration = params.data.daysAgo;
      let statut = params.data.statut;

      let result = "";
      if (duration > 14 && statut === 0) {
        result = "classNegative";
      } else if (duration > 6 && statut === 0) {
        result = "classWarning";
      }
      return result;
    },
    // hide: true,
  },
  {
    headerName: "Mutuelle",
    field: "nom_mutuelle",
    // hide: true,
  },
  {
    headerName: "age",
    field: "age",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "pathologie principale",
    field: "pathologie_principale",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "tel",
    field: "tel",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "tel 2",
    field: "tel2",
    // hide: true,
  },
  {
    headerName: "fk_id_clinique",
    field: "fk_id_clinique",
    hide: true,
  },

  {
    headerName: "date De Soumission",
    field: "dateDeSoumissionServer",
    filter: "dateDeSoumissionServer",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    headerName: "soumis",
    field: "dateDeSoumission_Lisible",
    // hide: true,
  },
  {
    headerName: "Nb de Jours",
    field: "daysAgo",
    cellClass: (params) => {
      let duration = params.data.daysAgo;
      let statut = params.data.statut;

      let result = "";
      if (duration > 14 && statut === 0) {
        result = "classNegative";
      } else if (duration > 6 && statut === 0) {
        result = "classWarning";
      }
      return result;
    },
    // hide: true,
  },
  {
    headerName: "statut",
    field: "statut",
    filterParams: {
      defaultOption: "startsWith",
    },
    cellRenderer: (params) => {
      let w;
      if (params.data.statut === 1) {
        w = <div>Validée</div>;
      } else {
        w = <div>En cours</div>;
      }
      return w;
    },
    cellClass: (params) =>
      params.data.statut === 1 ? "paidFooter" : "unpaidFooter",

    // hide: true,
  },

  {
    headerName: "contact",
    field: "contact",
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    hide: true,
  },
  {
    headerName: "contact",
    field: "contact_Lisible",
    // hide: true,
  },
  {
    floatingFilter: true,
    headerName: "commentaire",
    field: "comentaire",
    // hide: true,
  },
  {
    headerName: "idType_D_Operation",
    field: "idType_D_Operation",
    hide: true,
  },
  {
    floatingFilter: true,
    headerName: "Type D'Operation",
    field: "Nom_Type_D_Operationcol",
    // hide: true,
  },
];
export const columnDefs2 = [
  {
    headerName: "date_consultation_For_Server",
    field: "date_consultation_For_Server",
    hide: true,
  },
  {
    headerName: "Total du :",
    field: "total",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "date consultation",
    field: "date_consultation",
  },
  {
    headerName: "gain latent",
    field: "gain_latent",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "montant total",
    field: "sum_act",
    cellClass: (params) => (params.value > 0 ? "gain_latent" : null),
  },
  {
    headerName: "Payment_titre",
    field: "payment_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "payment",
    field: "payment",
    cellClass: (params) =>
      params.value === 0
        ? "unpaidFooter"
        : params.value > 0
          ? "paidFooter"
          : null,
  },
  {
    headerName: "reste_a_payer_titre",
    field: "reste_a_payer_titre",
    cellStyle: { textAlign: "center" },
  },
  {
    headerName: "reste a payer",
    field: "rest",
    cellStyle: { textAlign: "center" },
    // cellClass: (params) =>
    //   params.value === 0
    //     ? "paidFooter"
    //     : params.value > 0
    //     ? "unpaidFooter"
    //     : params.value < 0
    //     ? "overPaidFooter"
    //     : null,
  },
  // {
  //   headerName: "Numero",
  //   valueGetter: "node.rowIndex + 1",
  //   width: 90,
  //   suppressSizeToFit: false,
  //   checkboxSelection: true,
  //   minWidth: 90,
  //   maxWidth: 90,
  // },
];

// export const defaultColDef = {
//   sortable: true,
//   flex: 1,
//   // filter stuff
//   filter: true,
//   floatingFilter: true,
//   suppressMenu: true,
//   // end of filter stuff
//   minWidth: 100,
//   resizable: true,
//   filterParams: {
//     newRowsAction: "keep",
//   },
// };

export const topOptions = {
  alignedGrids: [],
  defaultColDef: {
    suppressMovable: true,
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    cellStyle: { textAlign: "center" },
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
  suppressHorizontalScroll: true,
};

export const bottomOptions = {
  alignedGrids: [],
  defaultColDef: {
    sortable: true,
    flex: 1,
    // filter stuff
    filter: true,
    floatingFilter: true,
    suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    resizable: true,
    filterParams: {
      newRowsAction: "keep",
    },
  },
};
